var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center-department-add"},[_c('center-add-title',[_vm._v(_vm._s(_vm.$t("message.cdepartment.addTitle")))]),_vm._t("addForm")],2)}
var staticRenderFns = []

export { render, staticRenderFns }